export const enum SectionIdEnum {
  intro = "intro",
  about = "about",
  skills = "skills",
  projects = "projects",
  contact = "contact",
}
